<template>
  <loader v-bind="{ loading }">
    <columns>
      <column class="is-4">
        <search-bar 
          v-model="filters.search"
          @run-search="runSearch"
          @clear-search="clearSearch"/>
      </column>
    </columns>

    <columns>
      <column>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Vendor</th>
              <th>Version</th>
              <th>Vulnerabilities</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="software in software.data" :key="software.id">
              <td>
                <router-link :to="{
                  name: 'software-manager',
                  params: {
                    ...$route.params,
                    software: software.software.id
                  }
                }">
                  <span>{{ software.software.name }}</span>
                </router-link>
              </td>
              <td>
                {{ software.version.version_number }}
              </td>
              <td>
                {{ software.version.vulnerabilities.length }}
              </td>
            </tr>
          </tbody>
        </table>
        <pager :pageable="software" @nav="goTo" jump-controls/>
      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'EnvironmentSoftware',
  data: () => ({
    software: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Software')
  },

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadSoftware()
  },

  methods: {
    loadSoftware() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({data}) => {
        this.software = data
        this.loading = false
      }, error => {
        this.loading = false
        console.log(error)
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    runSearch() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'environment-software',
        params: this.$route.params,
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'environment-software',
        params: this.$route.params,
        query: {}
      })
    }
  },

  watch: {
    '$route': 'loadSoftware'
  }
}
</script>
